import { render, staticRenderFns } from "./ProductsItemInfoDetail.vue?vue&type=template&id=3b8a8426&"
import script from "./ProductsItemInfoDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsItemInfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports